import { defineNuxtPlugin, useRequestEvent } from 'nuxt/app';
import type { H3Event, EventHandlerRequest } from 'h3';
import { hyperlinkComputeBindFromUrl, urlParts } from '~~/common/utils/urlParts';

export type RequestEventType = H3Event<EventHandlerRequest>['node']['req'] | undefined;

function createPluginProvides () {
  const requestEvent = useRequestEvent()?.node?.req;

  const urlPartsFunction = function (url: string): { isOuter: boolean, link: string } {
    return urlParts(getHost(requestEvent) || '', url);
  };
  const getHrefFunction = function (): string {
    return getHref(requestEvent);
  };
  const getHostFunction = function (): string | undefined {
    return getHost(requestEvent);
  };
  const hyperlinkComputeBindFromUrlFunction = function (url: string): { target?: string, href?: string, to?: string } {
    return hyperlinkComputeBindFromUrl(getHost(requestEvent) || '', url);
  };

  return {
    urlParts: urlPartsFunction,
    getHref: getHrefFunction,
    getHost: getHostFunction,
    hyperlinkComputeBindFromUrl: hyperlinkComputeBindFromUrlFunction,
  };
}

export type UrlPartsPluginProvides = ReturnType<typeof createPluginProvides>;

export default defineNuxtPlugin(() => {
  return {
    provide: createPluginProvides(),
  };
});

export function getHref (request: RequestEventType) {
  return import.meta.server ? `${request?.headers.host}${request?.url}` : window.location.href;
}

export function getHost (request: RequestEventType) {
  return import.meta.server ? request?.headers.host : window.location.host;
}
